<template>
  <v-btn
    data-testid="download-button"
    small
    text
    color="primary"
    @click="downloadFile(item.id)"
    :loading="loadingBtn"
  >
    {{ item.file_name }}
  </v-btn>
</template>

<script>
import { date, showAlert } from '../../../lib/helpers';

export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    loadingBtn: false,
  }),
  methods: {
    downloadFile(id) {
      this.loadingBtn = true;

      this.$store
        .dispatch('stockMid/bulk/downloadFile', {
          id,
          date,
          type: 'history',
        })
        .then((response) => {
          if (response) {
            window.location.href = response.download;
          } else {
            showAlert(
              this.$store,
              'File gagal di download !',
              'mdi-alert',
              'red'
            );
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
  },
};
</script>
